import { put, call, select } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import {
  editApplicationById,
  groupSignApplicationFailed,
  groupSignApplicationSuccessful,
} from '../actions';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';
import {
  addProgressLog, setProgressList, showProgressBar, signDocument,
} from '../../System/actions';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import processError from '../../../utils/processError';
import { dateFormatter } from '../../../utils/formatters';
import { nameBySave } from '../../../utils/utils';

const getStop = state => {
  const {
    [SYSTEM_MODULE]: {
      stopProgressBar = false,
    },
  } = state;
  return stopProgressBar;
};

export default function* groupSignApplication(action) {
  try {
    const {
      payload: {
        cert,
        filter,
        selected = [],
      } = {},
    } = action;
    let pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = addFilterQueryWithCondition(filter, pool);
    }
    yield put(showProgressBar({
      title: 'Пакетное подписание заявлений',
      text: 'group.sign.application',
    }));
    yield put(addProgressLog({ log: 'Загрузка списка документов.' }));
    if (!selected || !selected.length) {
      yield put(addProgressLog({ log: 'Не найдены заявления для подписания.' }));
      throw new Error('Не найдены заявления для подписания.');
    }
    yield put(addProgressLog({ log: 'Список заявлений загружен.' }));
    yield put(setProgressList({ progressCount: selected.length }));
    let stopSigned = false;
    for (let i = 0, len = selected.length; i < len; i++) {
      stopSigned = yield select(getStop);
      if (stopSigned) {
        break;
      }
      const documentId = selected[i];
      try {
        const signaturePromise = yield put(editApplicationById({ id: documentId, extra: { is_draft: false }, status: 1 }));
        const signatureDoc = yield signaturePromise;
        if (!signatureDoc || typeof signatureDoc === 'string') {
          throw new Error('Заявление не подписано.');
        }
        yield put(addProgressLog({ log: `Заявление c ID «${documentId}» подписано.`, incSuccess: true }));
      } catch (e) {
        yield put(addProgressLog({ log: `<span class='red-text'>Заявление c ID ${documentId || ''} не подписано. ${typeof e === 'string' ? e : ''}</span>`, incError: true }));
      }
    }
    yield put(addProgressLog({ log: 'Подписание окончено.' }));
    if (!stopSigned) {
      yield put(groupSignApplicationSuccessful());
      yield call(resolveActionPromise(action, {}));
    }
  } catch (e) {
    yield put(groupSignApplicationFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
